import { render, staticRenderFns } from "./personSearch.vue?vue&type=template&id=745d1c4c&scoped=true"
import script from "./personSearch.vue?vue&type=script&lang=js"
export * from "./personSearch.vue?vue&type=script&lang=js"
import style0 from "./personSearch.vue?vue&type=style&index=0&id=745d1c4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745d1c4c",
  null
  
)

export default component.exports